module.exports = __webpack_public_path__ + "769e6d64deb1ab00571794f823762138.fbx";